import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Label, Text } from "@gravity-ui/uikit";
import { getMemberStatusLabel } from "../utils";
export var MemberStatus = function (props) {
    if (props.memberStatus) {
        var memberStatusLabel = getMemberStatusLabel(props.memberStatus);
        return (_jsxs(Flex, { direction: "column", gap: 1, children: [_jsx(Text, { variant: "caption-2", color: "secondary", children: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0443\u0447\u0430\u0441\u0442\u0438\u044F" }), _jsx(Label, { theme: memberStatusLabel.theme, children: memberStatusLabel.text })] }));
    }
    return null;
};
